import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';

@Injectable()
export class RequisitionService extends WebService {

  public getRequisition(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append('_page', String(page));
    } else {
      params.append('_page', '1');
    }

    if (per_page !== null && per_page !== undefined) {
      params.append('_limit', String(per_page));
    } else {
      params.append('_limit', '10');
    }

    if (sort !== null && sort !== undefined) {
      params.append('_sort', String(sort));
    }

    if (query !== null && query !== undefined && query !== '') {
      params.append('_q', String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    params.append('_with', String('employee,company,venue,profile_survey,citation,requisition_justification.user.employee,requisition_task.employee,requisition_task.created_by,destination'));

    const options = new RequestOptions({ search: params, headers: this.headers });


    return this.http.get(`${this.apiUrl}/requisitions?${params}`, options);
  }

  public getRequisitionByCustomerGuide(id: number,
    page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append('_page', String(page));
    } else {
      params.append('_page', '1');
    }

    if (per_page !== null && per_page !== undefined) {
      params.append('_limit', String(per_page));
    } else {
      params.append('_limit', '10');
    }

    if (sort !== null && sort !== undefined) {
      params.append('_sort', String(sort));
    }

    if (query !== null && query !== undefined && query !== '') {
      params.append('_q', String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    params.append('_with', String('employee,company,venue,profile_survey,citation,requisition_justification.user.employee,requisition_task.employee,requisition_task.created_by,destination'));

    const options = new RequestOptions({ search: params, headers: this.headers });


    return this.http.get(`${this.apiUrl}/customer-guides/${id}/requisitions?${params}`, options);
  }


  public newRequisition(body: Object): Observable<Response> {
    return this.http.post(`${this.apiUrl}/requisitions`, JSON.stringify(body), { headers: this.headers });
  }

  public updateRequisition(id: number, body: Object): Observable<Response> {
    return this.http.patch(`${this.apiUrl}/requisitions/${id}`, JSON.stringify(body), { headers: this.headers });
  }

  public deleteRequisition(id: number): Observable<Response> {
    return this.http.delete(`${this.apiUrl}/requisitions/${id}`, { headers: this.headers });
  }

  public infoRequisition(id: number,_with: string): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    if(_with != '' && _with != undefined && _with != null )
      params.append('_with', String(_with));
    
    params.append('_sort', String('created_at'));
    
    
    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/requisitions/${id}?${params}`, options);
  }

  public getResumeRequisition(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append('_page', String(page));
    } else {
      params.append('_page', '1');
    }

    if (per_page !== null && per_page !== undefined) {
      params.append('_limit', String(per_page));
    } else {
      params.append('_limit', '10');
    }

    if (query !== null && query !== undefined && query !== '') {
      params.append('_q', String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    const options = new RequestOptions({ search: params, headers: this.headers });


    return this.http.get(`${this.apiUrl}/requisitions/resume?${params}`, options);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/requisition/requisition.service.ts